module.exports = __webpack_public_path__ + "static/media/image-anak-1.1097e3d7.png";